<template>
    <div class="mydetail-wrap">
        <div class="mydetail-top-menu">
          <button :class="{'menu-focus' : tabMenu==='use'}" @click.prevent="tabMenu='use'">사용내역<h2 class="blind" v-if="tabMenu==='use'">선택됨</h2></button>
          <button :class="{'menu-focus' : tabMenu==='charge'}" @click.prevent="tabMenu='charge'">구매/충전내역<h2 class="blind" v-if="tabMenu==='charge'">선택됨</h2></button>
          <button :class="{'menu-focus' : tabMenu==='gift'}" @click.prevent="tabMenu='gift'">선물내역<h2 class="blind" v-if="tabMenu==='gift'">선택됨</h2></button>
        </div>
        <my-detail-use v-if="tabMenu==='use'"/>
        <my-detail-charge v-if="tabMenu==='charge'"/>
        <my-detail-gift v-if="tabMenu==='gift'"/>
        </div>
</template>

<script>
import MyDetailUse from '@/views/myemarticon/mydetail/myDetailUse';
import MyDetailCharge from "@/views/myemarticon/mydetail/myDetailCharge";
import MyDetailGift from "@/views/myemarticon/mydetail/myDetailGift";
export default {
    name: 'MyDetail',
    components: {MyDetailGift, MyDetailUse, MyDetailCharge },
    data () {
        return {
          tabMenu: "use"
        }
    },
    mounted() {
        this.$heading('주문내역')
    },
    methods: {
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/myDetail.scss';
</style>